import { useQueryGetReportTemplateList } from 'api/queries/getReportTemplateList.query';

export type UseInitialTemplateCardProvider = ReturnType<typeof useInitialTemplateCardProvider>;

export const useInitialTemplateCardProvider = () => {
    const getReportTemplates = useQueryGetReportTemplateList(getPayloadForGetReportTemplate);

    return {
        api: {
            getReportTemplates,
        },
    };
};

const getPayloadForGetReportTemplate = {
    filter: {
        filters: [],
    },
};
